import { Period, TimeRange } from "./time-range";

/**
 * limitEndTime
 * Restrict the selectable AM/PM for the END time to be strictly later than the START time.
 * - If start is AM  -> end periods = ["AM","PM"] (both are >= in period-order; still allow same AM hour/minute to be refined by handlers)
 * - If start is PM  -> end periods = ["PM"] (can’t go back to AM)
 * - If start is empty or sentinel ("00:00", "00:00 AM/PM") -> no restriction
 *
 * NOTE: The TimeRange API only supports independent lists. This function intentionally
 * limits *periods* and leaves hours/minutes unchanged. Enforcing hour/minute strictness
 */
export function limitEndTime(startTime?: string | null): TimeRange {
	const all: TimeRange = {
		// keep picker's defaults (1–12, 0..55 step 5) by omitting
		periods: ["AM", "PM"],
	};

	if (!startTime) return all;

	const s = startTime.trim().toUpperCase();
	if (s === "00:00" || s === "00:00 AM" || s === "00:00 PM") {
		// treat sentinel/blank as unrestricted
		return all;
	}

	const parts = s.split(" ");
	const period = (parts[1] as Period) || "AM";

	if (period === "PM") {
		// strictly greater than any PM cannot be AM
		return { periods: ["PM"] };
	}

	// start is AM -> allow AM and PM (hour/minute strictness handled elsewhere)
	return { periods: ["AM", "PM"] };
}
